import { RestService } from './RestService.ts';

export const deleteAccount = (data: any) => {
  return RestService.post('auth/request-delete-account', data);
};
